import { render, staticRenderFns } from "./MakePymentsBtn.vue?vue&type=template&id=73e1d89c&"
import script from "./MakePymentsBtn.vue?vue&type=script&lang=js&"
export * from "./MakePymentsBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports